import { CommonCancellationsCrumbs } from './breadcrumb';

export const CancellationAirePresumedUnavailabilitySearchCrumbs = [
  ...CommonCancellationsCrumbs,
  {
    name: 'Ricerca Persona - Cancellazione AIRE per Irreperibilità Presunta',
    path: '/cancellazioni/cancellazioni-aire/irreperibilita-presunta',
  },
];

export const CancellationAirePresumedUnavailabiltyCrumbs = [
  ...CancellationAirePresumedUnavailabilitySearchCrumbs,
  {
    name: 'Cancellazione AIRE per Irreperibilità Presunta',
    path: '/cancellazioni/cancellazioni-aire/irreperibilita-presunta/cancellazione',
  },
];
